(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (() => {
    if (window.__varionGoldstandardMenuTree) return;
    window.__varionGoldstandardMenuTree = true;

    const selector = '.vgs-menu-details, .vgs-status__wildlands';
    const closeAll = (except) => {
      document.querySelectorAll(`${selector}[open]`).forEach((details) => {
        if (details !== except) details.removeAttribute('open');
      });
    };

    document.addEventListener('toggle', (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.matches(selector) || !details.open) return;
      closeAll(details);
    }, true);

    document.addEventListener('click', (event) => {
      if (event.target.closest(selector)) return;
      closeAll();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });

    const hoverMedia = window.matchMedia('(min-width: 990px)');
    const closeTimers = new WeakMap();
    const openHoverDetails = (details) => {
      if (!hoverMedia.matches || !(details instanceof HTMLDetailsElement) || !details.matches(selector)) return;
      window.clearTimeout(closeTimers.get(details));
      closeAll(details);
      details.setAttribute('open', '');
    };
    const scheduleHoverClose = (details) => {
      if (!hoverMedia.matches || !(details instanceof HTMLDetailsElement) || !details.matches(selector)) return;
      window.clearTimeout(closeTimers.get(details));
      const timer = window.setTimeout(() => {
        if (!details.matches(':hover')) details.removeAttribute('open');
      }, 140);
      closeTimers.set(details, timer);
    };
    const bindHover = () => {
      document.querySelectorAll(selector).forEach((details) => {
        if (details.dataset.vgsHoverBound === 'true') return;
        details.dataset.vgsHoverBound = 'true';

        details.addEventListener('mouseenter', () => {
          openHoverDetails(details);
        });

        details.addEventListener('mouseleave', () => {
          scheduleHoverClose(details);
        });
      });
    };

    const handleHoverIn = (event) => {
      openHoverDetails(event.target.closest?.(selector));
    };
    const handleHoverOut = (event) => {
      const details = event.target.closest?.(selector);
      if (!details || details.contains(event.relatedTarget)) return;
      scheduleHoverClose(details);
    };

    bindHover();
    document.addEventListener('mouseover', handleHoverIn, true);
    document.addEventListener('pointerover', handleHoverIn, true);
    document.addEventListener('mouseout', handleHoverOut, true);
    document.addEventListener('pointerout', handleHoverOut, true);
    document.addEventListener('shopify:section:load', bindHover);
  })();

  } catch(e) { console.error(e); }
})();
})();
